import React from "react";

const AllergyList = ({ items = [], onEdit }) => {
	return (
		<div className="inbox-body">
			<div className="inbox-body no-pad table-responsive">
				<table className="table table-inbox table-hover table-bordered">
					<thead>
						<tr>
							<th>sn</th>
							<th>Name</th>
							<th>Date </th>
							<th className="text-center">Edit </th>
						</tr>
					</thead>
					<tbody>
						{items.map((item, index) => (
							<tr key={index}>
								<td className="inbox-small-cells">
									<div className="todo-check pull-left">
										{index + 1}
									</div>
								</td>
								<td className="view-message">
									<h5>{item.name}</h5>
								</td>

								<td className="view-message">
									{Intl.DateTimeFormat("en-GB", {
										hour: "numeric",
										minute: "numeric",
										second: "numeric",
										hour12: false,
										month: "short",
										year: "numeric",
										weekday: "short",
										day: "numeric"
									}).format(
										new Date(parseInt(item.created_at))
									)}
								</td>

								<td className="view-message text-center">
									<button
										title="Update"
										onClick={() => onEdit(item)}
										className="mdl-button mdl-button--icon mdl-button--colored"
									>
										<i className="material-icons">edit</i>
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
				{items.length < 1 && (
					<div className="text-center m-t-10 m-b-10">
						<h4 className="text-pink">No Allergy is added yet!</h4>
					</div>
				)}
			</div>
		</div>
	);
};

export default AllergyList;
